import {FontFamilyType, FontOptionType} from '../models/editor/fontFamily'
import {AvailableLanguageType} from '../utils/helpers/currentLang'

interface ConfigType {
  websiteUrl: string
  apiUrl: string
  loggingRequests: boolean
  loggingResponses: boolean
  loggingNetworkErrors: boolean
  minZoom: number
  maxZoom: number
  minScale: number
  maxScale: number
  maxTextScale: number
  availableFontOptions: {
    [key in FontFamilyType]: {[key in FontOptionType]: boolean}
  }
  imageCompressionFormat: 'JPEG' | 'PNG' | 'WEBP'
  imageCompressionQuality: number
  imageCompressionResolution: number
  defaultLanguage: AvailableLanguageType
}

export const Config: ConfigType = {
  websiteUrl: 'https://poloforma.hu', // TODO: Env file
  apiUrl: 'https://poloforma.hu/wp-json/polotervezo/v1', // TODO: Env file
  loggingRequests: false,
  loggingResponses: false,
  loggingNetworkErrors: false,
  minZoom: 0.08,
  maxZoom: 20,
  minScale: 0.1,
  maxScale: 5,
  maxTextScale: 60,
  availableFontOptions: {
    Aclonica: {bold: true, italic: true, underline: true},
    'Bebas Neue': {bold: true, italic: true, underline: true},
    'Grand Hotel': {bold: true, italic: true, underline: true},
    'Luckiest Guy': {bold: true, italic: true, underline: true},
    Pacifico: {bold: true, italic: true, underline: true},
    'Pirata One': {bold: true, italic: true, underline: true},
    Ranchers: {bold: true, italic: true, underline: true},
    Righteous: {bold: true, italic: true, underline: true},
    Risque: {bold: true, italic: true, underline: true},
    Sriracha: {bold: true, italic: true, underline: true},
    'Aka Posse': {bold: false, italic: true, underline: true},
    Chomsky: {bold: true, italic: true, underline: true},
    Impact: {bold: true, italic: true, underline: true},
    'KG Let Her Go': {bold: true, italic: true, underline: true},
    'KG Love Is Love Is Love': {bold: true, italic: true, underline: true},
    'KG Luck of the Irish': {bold: true, italic: true, underline: true},
    'Victoria Typewriter': {bold: true, italic: true, underline: true},
    Indiana: {bold: true, italic: true, underline: true},
    Marker: {bold: true, italic: true, underline: true},
    Zurich: {bold: true, italic: true, underline: true},
    'Holtwood One SC': {bold: true, italic: true, underline: true},
    Laviossa: {bold: true, italic: true, underline: true},
    Redressed: {bold: true, italic: true, underline: true},
  },
  imageCompressionFormat: 'WEBP',
  imageCompressionQuality: 85,
  imageCompressionResolution: 1280,
  defaultLanguage: 'hu',
}
